import { useEffect, useState } from "react";
import { api, fmtMoney, fmtDate, openPdf } from "../lib/api";
import { PageHeader, DataTable, DateRangeFilter, filterByDate } from "../components/Shell";
import { FilePdf } from "@phosphor-icons/react";
import { useAuth } from "../context/AuthContext";
import DeleteButton from "../components/DeleteButton";

export default function Payments() {
  const { user } = useAuth();
  const isAdmin = user?.role === "admin";
  const [list, setList] = useState([]);
  const [range, setRange] = useState({ start: "", end: "" });
  const load = () => api.get("/payments").then((r) => setList(r.data));
  useEffect(() => {
    load();
  }, []);
  const filtered = filterByDate(list, "date_reglement", range.start, range.end);
  return (
    <div>
      <PageHeader
        testId="payments-header"
        title="Règlements & factures"
        subtitle="Historique des paiements avec accès direct aux factures PDF transmises par les danseuses."
        actions={<DateRangeFilter testId="payments-filter" start={range.start} end={range.end} onChange={setRange} />}
      />
      <DataTable
        columns={[
          { title: "Date", render: (p) => fmtDate(p.date_reglement) },
          { title: "Scène", render: (p) => <b>{p.nom_scene}</b> },
          { title: "Nom réel", key: "nom_reel" },
          { title: "Facture", render: (p) => p.numero_facture || "—" },
          {
            title: "PDF",
            render: (p) =>
              p.facture_pdf_path ? (
                <button
                  data-testid={`pay-view-pdf-${p.id}`}
                  onClick={() => openPdf(p.facture_pdf_path)}
                  className="inline-flex items-center gap-1.5 px-2.5 py-1 rounded-md border text-xs font-medium transition-all hover:scale-[1.03]"
                  style={{ color: "#f87171", borderColor: "#f8717150", background: "#f8717114" }}
                  title="Ouvrir la facture PDF"
                >
                  <FilePdf size={14} weight="fill" />
                  Voir PDF
                </button>
              ) : (
                <span className="text-xs text-[#71717a]">—</span>
              ),
          },
          { title: "Montant", align: "right", render: (p) => <b>{fmtMoney(p.montant)}</b> },
          { title: "Mode", key: "mode_reglement" },
          { title: "Référence", key: "reference" },
          {
            title: "IBAN",
            render: (p) => (
              <span className="font-mono text-xs text-[#a1a1aa]">
                {p.iban ? p.iban.slice(0, 8) + "…" + p.iban.slice(-4) : "—"}
              </span>
            ),
          },
          ...(isAdmin
            ? [{
                title: "",
                render: (p) => (
                  <DeleteButton
                    url={`/payments/${p.id}`}
                    label={`ce règlement de ${fmtMoney(p.montant)}`}
                    hint="La demande liée sera remise en 'à payer' si elle n'est plus entièrement réglée."
                    onDone={load}
                    testId={`delete-payment-${p.id}`}
                  />
                ),
              }]
            : []),
        ]}
        rows={filtered}
        rowKey="id"
        emptyText="Aucun règlement effectué"
      />
    </div>
  );
}
